import * as React from 'react'
import PerfectScrollbar from "perfect-scrollbar-react";
import MasonryGallery from 'src/share/components/Masonry/MasonryGallery';
import { NewsCardLoader } from 'src/share/components/ChartLoader/NewsCardLoader';
import NewsCard from './NewsCard';

const NewsArticles = ({ news, refElement, isAdmin, isLoading, onRemove }) => {
  function displayNews() {
    const newsArticles = news.map((record, index) => 
      <NewsCard key={record.id} isAdmin={isAdmin} refElement={news.length === index + 1 ? refElement : null} article={record} onRemove={onRemove} />
    );
    if (isLoading) {
      const skeletonCards = Array.apply(null, { length: 20 }).map((data, index) => <NewsCardLoader key={index} />);
      newsArticles.push(...skeletonCards);
    }
    return newsArticles;
  }
  return (
    <PerfectScrollbar>
      <div className="news-collection">
        <MasonryGallery>
          {displayNews()}
        </MasonryGallery>
      </div>
      {!isLoading && news.length === 0 && <p>No results were found.</p>}
    </PerfectScrollbar>
  )
}

export default NewsArticles
